import React, { useState } from "react";
import { FiCheck } from "react-icons/fi";
import AppShell from "../components/layout/AppShell";
import { Card, Input, Button } from "../components/ui";
import { useToast } from "../context/ToastContext";
import { changePassword } from "../api/users";

export default function ChangePassword() {
  const { notify } = useToast();
  const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const validate = () => {
    const next = {};
    if (!form.currentPassword) next.currentPassword = "Enter your current password.";
    if (!form.newPassword) next.newPassword = "Enter a new password.";
    else if (form.newPassword.length < 8) next.newPassword = "Must be at least 8 characters.";
    if (form.newPassword && form.newPassword === form.currentPassword) {
      next.newPassword = "New password must be different from your current password.";
    }
    if (form.confirmPassword !== form.newPassword) next.confirmPassword = "Passwords don't match.";
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSaving(true);
    try {
      await changePassword(form.currentPassword, form.newPassword);
      notify("Your password has been updated.", "success");
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
      setErrors({});
    } catch (error) {
      const message = error.response?.data?.message || "Couldn't update your password. Please try again.";
      // The backend is the source of truth for "is the current password
      // right" — surface its message directly under that field rather
      // than a generic toast, so it's clear exactly what to fix.
      if (message.toLowerCase().includes("current password")) {
        setErrors((prev) => ({ ...prev, currentPassword: message }));
      } else {
        notify(message, "error");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <AppShell title="Change password" subtitle="Update the password you use to sign in">
      <Card className="max-w-md p-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Current password"
            type="password"
            value={form.currentPassword}
            onChange={(e) => setForm({ ...form, currentPassword: e.target.value })}
            error={errors.currentPassword}
          />
          <Input
            label="New password"
            type="password"
            value={form.newPassword}
            onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
            error={errors.newPassword}
            hint="At least 8 characters."
          />
          <Input
            label="Confirm new password"
            type="password"
            value={form.confirmPassword}
            onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
            error={errors.confirmPassword}
          />
          <Button type="submit" loading={saving} className="w-full justify-center">
            <FiCheck className="h-4 w-4" /> Update password
          </Button>
        </form>
      </Card>
    </AppShell>
  );
}
